import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { map, tap } from 'rxjs';
import { Router } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';

@Injectable({
  providedIn: 'root'
})
export class TariffService {
  constructor(
    private readonly http: HttpClient,
    private readonly router: Router,
    private readonly keycloakService: KeycloakService,
  ) { }

  public getTariffs() {
    return this.http.get<any>(environment.baseURL + '/tariff')
      .pipe(map(res => res.data));
  }

  public getMyTariff() {
    return this.http.get<any>(environment.baseURL + '/tariff/my')
      .pipe(map(res => res.data));
  }

  public getPaymentNotification() {
    return this.http.get<any>(environment.baseURL + '/payment/all')
      .pipe(map(res => res.data));
  }

  usePromoCode(payload: { promo_code: string }) {
    return this.http.post<any>(environment.baseURL + '/tariff/check', payload)
      .pipe(map(res => res.data));
  }

  checkPromo(payload: { promo_code: string }) {
    return this.http.post<any>(environment.baseURL + '/tariff', payload)
      .pipe(map(res => res.data));
  }

  public activeTrial(payload: any) {
    const url = environment.baseURL + '/payment/activate-demo';
    return this.http.put<any>(url, payload)
      .pipe(map(res => res.data));
  }

}
